<template>
  <div v-if="!localIsSubjectBound" class="overlay" @click.stop>
    <div class="overlay-content" v-loading="loading">
      <div v-if="!loading && localBindingInfo">
        <p>本班级{{ localBindingInfo.subjectName }}科目还没有绑定老师，选择以下两个方式让{{ localBindingInfo.subjectName }}老师绑定本班，<br/>您也可以点击：<el-button 
            @click="switchSubject" 
            class="subject-toggle-btn"
            :class="subjectClass"
            style="color: white; width: 60px; height: 30px; font-size: 12px; padding: 4px; margin: 0 5px; box-shadow: 0 2px 4px rgba(0,0,0,0.2); cursor: pointer;">
            切换科目
          </el-button>来继续切换科目。</p>
        <div class="binding-methods">
          <div class="method">
            <h4>方式一：</h4>
            <p>{{ localBindingInfo.subjectName }}老师手机扫描下方二维码加入</p>
            <div v-if="localBindingQrCodeUrl" class="qr-code-container">
              <img :src="localBindingQrCodeUrl" alt="绑定二维码" class="qr-code" />
            </div>
          </div>
          <div class="method">
            <h4>方式二：</h4>
            <p>复制下方链接给{{ localBindingInfo.subjectName }}老师加入：</p>
            <div class="binding-link">
              <span class="link-text">{{ localBindingInfo.pcBindingLink }}</span>
              <el-button size="mini" type="primary" @click="copyPcLink">复制链接</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SubjectBindingOverlay',
  props: {
    classId: {
      type: Number,
      default: null
    },
    subjectIndex: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      localIsSubjectBound: true,
      localBindingInfo: null,
      localBindingQrCodeUrl: '',
      loading: false
    }
  },
  computed: {
    subjectClass() {
      switch(this.subjectIndex) {
        case 0:
          return 'chinese-subject';
        case 1:
          return 'math-subject';
        case 2:
          return 'english-subject';
        default:
          return 'math-subject';
      }
    }
  },
  watch: {
    localIsSubjectBound(newVal, oldVal) {
      if (oldVal === false && newVal === true) {
        this.enablePageScroll();
      }
      this.$emit('binding-status-changed', newVal);
    }
  },
  methods: {
    switchSubject() {
      this.$emit('switch-subject');
    },
    copyPcLink() {
      // 复制PC端链接
      if (this.localBindingInfo && this.localBindingInfo.pcBindingLink) {
        navigator.clipboard.writeText(this.localBindingInfo.pcBindingLink)
            .then(() => {
              this.$message({
                type: 'success',
                message: 'PC端绑定链接复制成功!'
              });
            })
            .catch(err => {
              console.error('复制链接失败:', err);
              this.$message({
                type: 'error',
                message: '复制链接失败，请手动复制'
              });
            });
      }
    },
    enablePageScroll() {
      document.body.style.overflow = 'auto';
    },
    
    // 检查当前科目是否已绑定老师
    checkSubjectBinding() {
      if (!this.classId) {
        console.warn('No classId available for checking subject binding')
        return
      }

      const subjectId = this.subjectIndex + 1

      this.loading = true

      this.$http.get(`/teacherClass/checkBinding?classId=${this.classId}&subjectId=${subjectId}`)
          .then(response => {
            this.localIsSubjectBound = response.data.bound;
            this.localBindingInfo = response.data;

            if (!response.data.bound) {
              this.generateBindingInfo().finally(() => {
                this.loading = false
              })
            } else {
              this.loading = false
            }
          })
          .catch(error => {
            console.error('检查科目绑定状态失败:', error)
            this.loading = false
          })
    },
    
    async generateBindingInfo() {
      // 清空之前的绑定信息
      this.localBindingQrCodeUrl = '';

      // 获取班级识别码
      const classCode = await this.loadClassCode();

      // 获取当前科目ID
      const subjectId = this.subjectIndex + 1;

      try {
        // 请求后端生成绑定代码
        const response = await this.$http.get(`/teacherBinding/generateBindingCode?classId=${this.classId}&subjectId=${subjectId}`);

        if (response.data.success) {
          // 获取当前页面的基础URL
          const baseUrl = window.location.origin;

          // 构造完整的URL
          const mobileUrl = baseUrl + response.data.mobileEndpoint;
          const pcUrl = baseUrl + response.data.pcEndpoint;

          // 生成二维码
          const QRCode = require('qrcode');

          // 使用移动端绑定链接生成二维码
          QRCode.toDataURL(mobileUrl, {width: 200, margin: 2})
              .then(url => {
                this.localBindingQrCodeUrl = url;
              })
              .catch(err => {
                console.error('生成二维码失败:', err);
                this.$message.error('生成二维码失败，请稍后重试');
              });

          // 设置绑定信息
          const newBindingInfo = {
            subjectName: this.getSubjectName(),
            bindingLink: mobileUrl,  // 移动端绑定链接
            pcBindingLink: pcUrl,    // PC端绑定链接
            classCode: classCode              // 班级识别码
          };
          
          this.localBindingInfo = newBindingInfo;
        } else {
          console.error('生成绑定代码失败:', response.data.message);
          this.$message.error('生成绑定代码失败: ' + response.data.message);
        }
      } catch (error) {
        console.error('请求绑定代码失败:', error);
        this.$message.error('请求绑定代码失败，请稍后重试');
      }
    },
    
    async loadClassCode() {
      try {
        const response = await this.$http.get(`/classes/${this.classId}`);
        if (response.data.success && response.data.class) {
          return response.data.class.classCode;
        }
      } catch (error) {
        console.error('获取班级识别码失败:', error);
      }
      
      return '';
    },
    
    getSubjectName() {
      const subjects = ['语文', '数学', '英语'];
      return subjects[this.subjectIndex] || '语文';
    }
  },
  // 当组件挂载时，如果遮罩层显示，禁用页面滚动
  mounted() {
    if (!this.localIsSubjectBound && this.localBindingInfo) {
      document.body.style.overflow = 'hidden';
    }
  },
  // 当组件销毁时，启用页面滚动
  beforeDestroy() {
    this.enablePageScroll();
  }
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.overlay-content {
  background: white;
  padding: 30px;
  border-radius: 10px;
  max-width: 550px;
  width: 80%;
  max-height: 80%;
  min-height: 200px;
  overflow-y: auto;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  overflow-x: hidden;
}

.binding-methods {
  margin-top: 20px;
}

.method {
  margin-bottom: 25px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.method:last-child {
  margin-bottom: 0;
  padding-bottom: 15px;
}

.method h4 {
  margin-top: 0;
  margin-bottom: 10px;
  color: #333;
  font-size: 16px;
}

.method p {
  margin: 10px 0;
  color: #666;
  line-height: 1.5;
}

.qr-code-container {
  display: flex;
  justify-content: center;
  margin: 15px 0;
}

.qr-code {
  max-width: 150px;
  max-height: 150px;
  border: 1px solid #ddd;
  padding: 5px;
  border-radius: 5px;
}

.binding-link {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
  width: 100%;
}

.link-text {
  padding: 8px 12px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 4px;
  white-space: nowrap;
  font-size: 14px;
  font-family: monospace;
  line-height: 1.4;
}

.subject-toggle-btn {
  width: 80px;
  height: 40px;
  font-size: 14px;
  font-weight: bold;
  padding: 6px;
  text-align: center;
  margin: 0;
  border-radius: 10px;
  box-shadow: 0 3px 6px rgba(0,0,0,0.1);
  transition: all 0.3s ease;
  color: white;
  flex-shrink: 0;
  display: inline-block;
  vertical-align: middle;
}

.subject-toggle-btn.chinese-subject {
  background: linear-gradient(135deg, #FFA500, #FF8C00);
  border: 2px solid #FFA500;
}

.subject-toggle-btn.math-subject {
  background: linear-gradient(135deg, #409EFF, #64b5f6);
  border: 2px solid #409EFF;
}

.subject-toggle-btn.english-subject {
  background: linear-gradient(135deg, #F56C6C, #ff4242);
  border: 2px solid #F56C6C;
}

.subject-toggle-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
}
</style>